import{ useState, forwardRef, useImperativeHandle } from 'react';
import clsx from 'clsx'
import { Box, Button, Modal, Typography} from '@mui/material';
import WarningRoundedIcon from '@mui/icons-material/WarningRounded';
import useMediaQuery from '../../base/useMediaQuery';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  maxWidth: 326,
  width: "96%",
  bgcolor: 'background.paper',
  borderRadius: "18px",
  p: 3,
};

interface IProps {
  message: string;
  button1Title: string;
  onPressBtn1: Function;
  button2Title?: string;
  onPressBtn2?: Function;
}

const ConfirmationDialog = forwardRef((props: IProps, ref: any) => {
  const {
    message,
    includeTitle,
    button1Title,
    onPressBtn1,
    button2Title,
    onPressBtn2,
  } = props;

  const isDeskTop = useMediaQuery('(min-width: 400px)');

  const [openConfirmation, setOpenConfirmation] = useState(false)

  useImperativeHandle(ref, () => ({
    show() {
      setOpenConfirmation(true)
    }
  }));

  const onPressButton1 = () => {
    setOpenConfirmation(false)
    onPressBtn1()
  }

  const onPressButton2 = () => {
    setOpenConfirmation(false)
    onPressBtn2 && onPressBtn2();
  }

  return (
    <>
      <Modal 
        open={openConfirmation} 
        onClose={() => setOpenConfirmation(false)}
        disableAutoFocus sx={{ bgcolor: '#F4F4F489', zIndex: 1000000 }} hideBackdrop
      >
        <Box sx={style} className="shadow-[0_0_14px_grey]">
          <Typography className={clsx("py-2 font-['Matter-Medium'] leading-[24px] text-center", {
            "text-[13px]": !isDeskTop,
            "text-[16px]": isDeskTop
          })}>
            {message}
          </Typography>
          <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', pt: 2 }}>
            <Button className="px-5 font-['Matter-Medium'] leading-[24px] normal-case text-[16px] text-black border-[1px] border-[#000] border-solid rounded-full" onClick={onPressButton1}>
              {button1Title}
            </Button>
            {button2Title && (
                <Button variant="contained" onClick={onPressButton2} className="bg-[#000000] px-5 rounded-full font-['Matter-Medium'] leading-[24px] normal-case text-[16px] text-white">
                    {button2Title}
                </Button>
            )}
          </Box>
        </Box>
      </Modal>
    </>
  );
})

export default ConfirmationDialog;